import { createContext } from 'react'

export interface ChatWidgetState {
  closeWidget: () => void
  newChat: () => void
}

export const ChatWidgetContext = createContext<ChatWidgetState>({
  closeWidget: () => {},
  newChat: () => {},
})
